import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import type { KnowledgeResponse } from "entities/knowledge/types";
import { getPublicationFetchParams } from "entities/publication/sagas/utils";
import { fetchVideosForTopicFailure, fetchVideosForTopicSuccess } from "entities/videos/actions";
import type { VideosFetchForTopicAction } from "entities/videos/actionTypes";

export function* fetchVideosForTopicSaga(action: VideosFetchForTopicAction) {
  const { id } = action.payload;
  try {
    const payload: KnowledgeResponse[] = yield apiFetch(`topic/${id}/media`, {
      queryParams: {
        ...getPublicationFetchParams(action.payload),
        content_type: "Videos",
      },
      ...(action.meta.forceRefresh
        ? {
            headers: {
              "Cache-Control": "no-cache, no-store, must-revalidate",
            },
          }
        : {}),
    });

    yield put(fetchVideosForTopicSuccess({ topicId: id, data: payload }, action.payload));
  } catch {
    yield put(fetchVideosForTopicFailure({ logoutOnAuthError: true, searchCriteria: action.payload }));
  }
}
